export default __webpack_public_path__ + "static/media/SquareLogo.d6e1f347.png";